import { useQuery } from "@tanstack/react-query";
import queryKey from "../../enumerations/queryKey";
import {
  apiGetProductCountryList,
  apiGetProductDays,
  apiGetProductItemDetail,
  apiGetProductMethods,
  apiGetSeoList,
} from "./service";

export const useGetProductCountryList = (params: any, options: any) => {
  return useQuery<any>({
    queryKey: [queryKey.PRODUCT_COUNTRY_LIST, params.search_str],
    queryFn: () =>
      apiGetProductCountryList(params).then((res: any) => res.data.data),
    ...options,
  });
};

export const useGetProductItemDetail = (params: any, options: any) => {
  return useQuery<any>({
    queryKey: [queryKey.PRODUCT_ITEM_DETAIL, params.product_id],
    queryFn: () =>
      apiGetProductItemDetail(params).then((res: any) => res.data.data),
    ...options,
  });
};

export const useGetProductItemMethods = (params: any, options: any) => {
  return useQuery<any>({
    queryKey: [queryKey.PRODUCT_ITEM_METHOD, params],
    queryFn: () =>
      apiGetProductMethods(params).then((res: any) => res.data.data),
    ...options,
  });
};

export const useGetProductItemDays = (params: any, options: any) => {
  return useQuery<any>({
    queryKey: [queryKey.PRODUCT_ITEM_DAYS, params],
    queryFn: () => apiGetProductDays(params).then((res: any) => res.data.data),
    ...options,
  });
};

export const useGetSeoList = (params: any, options: any) => {
  return useQuery<any>({
    queryKey: [queryKey.SEO_LIST, params],
    queryFn: () => apiGetSeoList(params).then((res: any) => res.data.data),
    ...options,
  });
};
